/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DirectionsService } from '../../models/directions-service';
import { Gpx } from '../../models/gpx';

export interface GetGpxRouteUsingPost$Xml$Params {

/**
 * Specifies the route profile.
 */
  profile: 'driving-car' | 'driving-hgv' | 'cycling-regular' | 'cycling-road' | 'cycling-mountain' | 'cycling-electric' | 'foot-walking' | 'foot-hiking' | 'wheelchair';
  
    /**
     * The request payload
     */
    body: DirectionsService
}

export function getGpxRouteUsingPost$Xml(http: HttpClient, rootUrl: string, params: GetGpxRouteUsingPost$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<Gpx>> {
  const rb = new RequestBuilder(rootUrl, getGpxRouteUsingPost$Xml.PATH, 'post');
  if (params) {
    rb.path('profile', params.profile, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/gpx+xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Gpx>;
    })
  );
}

getGpxRouteUsingPost$Xml.PATH = '/v2/directions/{profile}/gpx';
